export default __webpack_public_path__ + "static/media/kitap2.e4ed94f1.jpg";